var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"text":"Icon Before","icon":"add"}})
}
var staticRenderFns = []

export { render, staticRenderFns }